import React, { useEffect, useState } from "react";
import Chatheader from "../chatheader/chatheader";
import { useStateValue } from '../../../../stateprovider';
import "./profile.css";
import profileImage from "../../../../assets/Ellipse 28.png";
import { useNavigate } from "react-router-dom";

const ProfileComp = () => {
    const [{ }, dispatch] = useStateValue();
    const navigate = useNavigate();
    const [selectedImage, setSelectedImage] = useState(null);

    useEffect(() => {
        dispatch({
            type: "APP_NAV_STATE",
            appnav: true
        });
        dispatch({
            type: "APP_ICON_STATE",
            appIconState: 2
        })
    }, []);

    const Button = [
        { text: "view summary note", url: "/medical-record" },
        { text: "Request medical record", url: "#" },
        { text: "sign out", url: "/sign-out" }
    ];

    return <div className="app_complaint app_extend">
        <Chatheader />
        <div className="app_summaryready_container" style={{height: "unset"}}>
            <img src={selectedImage === null ? profileImage : URL.createObjectURL(selectedImage)} alt="" 
            />
            <div className="app_profile_input">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g opacity="0.8">
                    <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </g>
            </svg>
                     <input type="file" accept="image/*" 
                     onChange={(e)=> setSelectedImage(e.target.files[0])}
                     />
            </div>
            <div className="app_profile_row">
                <div className="app_profile_col">
                    <p>Edit profile</p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M11 4H4C3.46957 4 2.96086 4.21071 2.58579 4.58579C2.21071 4.96086 2 5.46957 2 6V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V13" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M18.5 2.50001C18.8978 2.10219 19.4374 1.87869 20 1.87869C20.5626 1.87869 21.1022 2.10219 21.5 2.50001C21.8978 2.89784 22.1213 3.4374 22.1213 4.00001C22.1213 4.56262 21.8978 5.10219 21.5 5.50001L12 15L8 16L9 12L18.5 2.50001Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </div>

             {Button.map((b, index) => {
             return   <button key={index} onClick={()=> navigate(b.url)} style={index === 0 ? { background: "#FF1A51" ,
                border: "1px solid #FF1A51"} : {}}>
                    {b.text}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M5 12H19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12 5L19 12L12 19" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
             })  }
            </div>
        </div>

    </div>
}
export default ProfileComp;